
import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Switch,
    FormControl,
    FormLabel,
    FormControlLabel,
    Dialog,
    DialogTitle,
    Divider,
    Slide,
    InputLabel,
    Select,
    Grid,
    Button,
    DialogActions,
    LinearProgress,
    Container,
    CircularProgress,
    Paper
} from "@mui/material";
import {ContainerClasses} from '../../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PersonIcon from "@mui/icons-material/Person";
import {useTheme} from '@mui/material/styles';
import {LookupFieldModel,
        ObjectModel,
        ObjectJSON,
        ObjectFactory,
        RecordModel,
        RecordFactory,
        ActionModel,
        EmailUserModel,
        EmailConnectorModel,
        EmailConnectorFactory,
        EmailContextRecordModel,
        EmailContextObjectModel,
        EmailTemplateModel,
        EmailTemplateFactory,
        EmailMessageModel,
        EmailPreviewModel,
        EmailPreviewJSON,
        EmailPreviewFactory,
        FieldMetadataModel,
        LayoutFieldFactory,
        LayoutSectionFactory,
        LayoutRelatedListModel} from '../../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../../components/searchField/SearchField";
import {LayoutSectionComponent} from "../../../components/layoutSection/LayoutSection";
import {CalendarDialogComponent} from "../../../components/calendarDialog/CalendarDialog";
import {EmailFromComponent} from "../../../components/email/EmailFrom";
import { formatDate, formatDatetime } from "../../../utils/dateFunctions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router";
import {setSelectedTabObject,
        getSelectedTabObject} from "../../../app/globalLayoutSlice";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getAppName, getObjectName, getRecordUuid } from "../../../utils/helperRouter";
import {EmailFieldComponent} from "../../fields/EmailField";
import {UrlFieldComponent} from "../../fields/UrlField";
import {UUIDFieldComponent} from "../../fields/UUIDField";
import {BigAutoFieldComponent} from "../../fields/BigAutoField";
import {AutoIdentifierNameFieldComponent} from "../../fields/AutoIdentifierNameField";
import {TextFieldComponent} from "../../fields/TextField";
import {JsonFieldComponent} from "../../fields/JsonField";
import {FileFieldComponent} from "../../fields/FileField";
import {TextFieldEncryptedComponent} from "../../fields/TextFieldEncrypted";
import {DecimalFieldComponent} from "../../fields/DecimalField";
import {BooleanFieldComponent} from "../../fields/BooleanField";
import {SelectFieldComponent} from "../../fields/SelectField";
import {DateFieldComponent} from "../../fields/DateField";
import {DateTimeFieldComponent} from "../../fields/DateTimeField";
import {LookupDialogComponent} from "../../fields/LookupDialog";
import {EmailPreviewComponent} from "../../email/EmailPreview";
import {useSnackbar} from "notistack";

//SHIFT THIS AT SOME POINT TO OTHER ROUTINE
import { useAuth } from "../../../hooks/useAuth";
import {downloadFile as downloadFileApi} from "../../../screens/record/recordSlice";
import {getFieldError} from '../../../utils/fieldValidations';
import Config from "../../../config";
import { fetchEmailPreviews } from "../../../services/emailApi";

/*

COMPONENT FOR RENDERING AN EMAIL TEMPLATE

*/


export const EmailTemplatePreviewComponent: React.FC<{
  data: any,
  action: ActionModel
}> = ({
  data,
  action
}) => {

  const styles = ContainerClasses();

  const dispatch = useDispatch<any>();

  const navigate = useNavigate();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();


  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  const [availableEmailConnectors, setAvailableEmailConnectors] = useState<EmailConnectorModel[]>([]);
  const [selectedEmailConnector, setSelectedEmailConnector] = useState<EmailConnectorModel | null>(null);

  const [contextObjects, setContextObjects] = useState<EmailContextObjectModel[]>([]);
  const [selectedContextObject, setSelectedContextObject] = useState<EmailContextObjectModel | null>(null);

  const [contextRecipientObject, setContextRecipientObject] = useState<EmailContextObjectModel | null>(null);
  const [selectedRecipients, setSelectedRecipients] = useState<RecordModel[]>([]);

  const [renderedTemplates, setRenderedTemplates] = useState<EmailPreviewModel[]>([]);
  const [renderedTemplate, setRenderedTemplate] = useState<EmailPreviewModel | null>(null);

  const [openLookupDialog, setOpenLookupDialog] = useState<boolean>(false);

  const [allEmailPreviews, setAllEmailPreviews] = useState<EmailPreviewModel[]>([]);

  const [template, setTemplate] = useState<EmailTemplateModel | null>(null);

  useEffect(() => {
    if(data?.email_connectors){
      const thisFactory = new EmailConnectorFactory()
      const connectors = data.email_connectors.map((thisJSON: any) => thisFactory.fromJSON(thisJSON));
      setAvailableEmailConnectors(connectors);
      if(connectors.length > 0){
        setSelectedEmailConnector(connectors[0]);
      }
    }

    if(data?.email_template){
      //create a layout field for each object
      const thisContextObjects = data.email_template.context_objects.map((thisJSON: any) => {
                                     const thisContextObject = new EmailContextObjectModel().fromJSON(thisJSON);
                                     return thisContextObject
      })

      setContextObjects(thisContextObjects);
    }

    if(data?.email_template.context_recipient){
      const thisContextRecipientObject = new EmailContextObjectModel().fromJSON(data.email_template.context_recipient);
      setContextRecipientObject(thisContextRecipientObject)
    }

    if(data?.email_template){
      const emailTemplateFactory = new EmailTemplateFactory()
      setTemplate(emailTemplateFactory.fromJSON(data.email_template));
    }

  }, [data]);



  useEffect(() => {
    if(errorMessage){
     enqueueSnackbar(errorMessage, {
          variant: "error",
       });
    setErrorMessage(null)
    }

    if(successMessage){
     enqueueSnackbar(successMessage, {
          variant: "success",
       });
    setSuccessMessage(null)
    }
  }, [errorMessage, successMessage]); // eslint-disable-line react-hooks/exhaustive-deps


  const handlePreview = () => {

    const allErrorsA = contextObjects.map((thisContextObject) => {
      //check all context object fields in this section for errors
      if(!thisContextObject.referencedRecord.Uuid_sys) return true;
        return false
      })

    const thisErrorA = allErrorsA.includes(true);

    if(thisErrorA === true){
      setErrorMessage("Error: some required fields are not defined")
      return
    }

    if(!contextRecipientObject){
      setErrorMessage("Error: recipient object not defined")
      return
    }

    //check if recipient is defined
    if(selectedRecipients.length < 1){
      setErrorMessage("Error: No recipients specified")
      return
    }

    if(!selectedEmailConnector){
      setErrorMessage("Error: email connector (From field) not specified")
      return
    }

    if(!template){
      setErrorMessage("Error: email template not defined")
      return
    }

    const emailMessages = selectedRecipients.map((thisRecipient: RecordModel) => {
      const emailMessage = new EmailMessageModel();
      emailMessage.setSender(selectedEmailConnector);
      emailMessage.setEmailTemplate(template);
      emailMessage.setContextRecipient(contextRecipientObject, thisRecipient)

      contextObjects.map((thisContextObject: EmailContextObjectModel) => {
           emailMessage.setContextRecord(thisContextObject, thisContextObject.referencedRecord)
        })

      return emailMessage
    })

    fetchEmailPreviews(accessToken, emailMessages)
        .then((emailPreviews) => {
          setRenderedTemplates(emailPreviews);
          setSuccessMessage("Email template(s) rendered successfully.")
        })
        .catch((err) => {
          setErrorMessage(err.message)
        })

  }


  const handleChangeEmailConnector = (event: any) => {
    const thisUuid = event.target.value;
    const thisEmailConnector = availableEmailConnectors.find((connector: EmailConnectorModel) => connector.Uuid_sys ===thisUuid);
    if(thisEmailConnector){
      setSelectedEmailConnector(thisEmailConnector);
    }
  }

   const handleChangeContextObject = (newLookupValue: RecordModel | null) => {

     if(selectedContextObject?.ContextType_c === 'Recipient' &&
        newLookupValue){
       setSelectedRecipients(previous => {
         const updatedItems = [...previous];
         const thisRecipient = updatedItems.find((recipient: RecordModel) => recipient.fields.Uuid_sys.fieldValue === newLookupValue.fields.Uuid_sys.fieldValue)
         if(!thisRecipient){
           updatedItems.push(newLookupValue)
         }
         return updatedItems;
       })
     }

     if(selectedContextObject?.ContextType_c === 'Custom'){
       //update the state of contextObjects
       setContextObjects(previous => {
         //clone previous state
         const updatedItems = [...previous];
         const thisContextObject = updatedItems.find((contextObject: EmailContextObjectModel) => contextObject.Uuid_sys === selectedContextObject?.Uuid_sys);
         if(thisContextObject) thisContextObject.setReferencedRecord(newLookupValue)
         return updatedItems;
       })
     }

      setSelectedContextObject(null)
      setOpenLookupDialog(false)
//
  }




  const recipientObjectElement = (contextObject: EmailContextObjectModel,
                                  contextRecord: RecordModel | null = null) => {

    const thisValue = contextRecord?.fields.lookup_display_value.fieldValue;

    const onSelect = () => {
     enqueueSnackbar("Redirect from here is not yet implemented", {
          variant: "error",
       });
       return
    }

    const handleSearch = () => {
      setSelectedContextObject(contextObject);
      setOpenLookupDialog(!openLookupDialog);
    }

    const handleRemove = () => {
      if(contextRecord){
        setSelectedRecipients(previous => {
          return previous.filter((thisRecipient: RecordModel) => thisRecipient.fields.Uuid_sys.fieldValue !== contextRecord.fields.Uuid_sys.fieldValue);
        });
    }
  }

    const error = () => {
      if(selectedRecipients.length < 1) return true;
//      if(!contextObject.referencedRecord.Uuid_sys) return true;
      return false
    };

    const getKey = () => {
      if(thisValue) return `${contextObject.Uuid_sys}-${thisValue}`
      return contextObject.Uuid_sys
    }

    return (
      <Grid item key={getKey()}>
        <TextField
          fullWidth
          disabled
          error={error()}
          required={true}
          size="small"
          label={`To (${contextObject.ContextKey_c} -- ${contextObject.ReferencedObject_c.Label_sys})`}
          variant="filled"
          value={thisValue ?? ''}
          inputProps={{
            maxLength: 255,
            onClick: () => console.log("field clicked")
          }}
          InputProps={{
            disableUnderline: true,
            startAdornment:(
              <InputAdornment position="start">
                <IconButton
                   disabled={thisValue === undefined || thisValue === null ? true : false}
                   size="small"
                   onClick={() => onSelect()}>
                     <OpenInNewIcon />
                 </IconButton>
               </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                 {contextRecord &&
                  <IconButton size="small" onClick={() => handleRemove()}>
                    <DeleteForeverIcon />
                  </IconButton>}
                 {!contextRecord &&
                  <IconButton size="small" onClick={() => handleSearch()}>
                    <SearchIcon />
                  </IconButton>}
            </InputAdornment>
            )
          }}
        />
      </Grid>
    )
  }





  const contextObjectElement = (contextObject: EmailContextObjectModel) => {

    const thisValue = contextObject.referencedRecord.lookupDisplayValue;

    const onSelect = () => {
     enqueueSnackbar("Redirect from here is not yet implemented", {
          variant: "error",
       });
       return
      //problem here: the action dialog remains open, this, disable for now
      const uuidValue = contextObject.referencedRecord.Uuid_sys;
      const objectApiName = contextObject.ReferencedObject_c.ApiName_sys;
      const appApiName = getAppName(appName)
      navigate(`/${appApiName}/${objectApiName}/${uuidValue}`);
    }

    const handleSearch = () => {
      setSelectedContextObject(contextObject);
      setOpenLookupDialog(!openLookupDialog);
    }

    const error = () => {
      if(!contextObject.referencedRecord.Uuid_sys) return true;
      return false
    };


    return (
      <Grid item xs={12} md={6} key={`${contextObject.Uuid_sys}`}>
        <TextField
          fullWidth
          disabled
          error={error()}
          required={true}
          size="small"
          label={`${contextObject.ContextKey_c} (${contextObject.ReferencedObject_c.Label_sys} context)`}
          variant="filled"
          value={thisValue ?? ''}
          inputProps={{
            maxLength: 255,
            onClick: () => console.log("field clicked")
          }}
          InputProps={{
            disableUnderline: true,
            startAdornment:(
              <InputAdornment position="start">
                <IconButton
                   disabled={thisValue === undefined || thisValue === null ? true : false}
                   size="small"
                   onClick={() => onSelect()}>
                     <OpenInNewIcon />
                 </IconButton>
               </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                 <IconButton size="small" onClick={() => handleSearch()}>
                 <SearchIcon />
                </IconButton>
            </InputAdornment>
          )
         }}
      />
    </Grid>
    )
  }

   return (
     <Box>
       {selectedContextObject &&
        <LookupDialogComponent
          objectApiName={selectedContextObject.ReferencedObject_c.ApiName_sys}
          openDialog={openLookupDialog}
          onCloseDialog={() => {
            setSelectedContextObject(null);
            setOpenLookupDialog(false);
              }}
          onSelect={handleChangeContextObject}
        />
        }

        {/*ALL ADDRESS FIELDS (FROM, TO, ETC)*/}
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
            <Typography>
              Address Fields
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>

              <Grid item xs={12} md={6}>
                <EmailFromComponent
                    selectedEmailConnector = {selectedEmailConnector}
                    emailConnectors = {availableEmailConnectors}
                    onChange = {handleChangeEmailConnector}
                 />
              </Grid>



              <Grid item xs={12} md={6}>
                <Grid container spacing={2} direction="column">
                  {contextRecipientObject &&
                   selectedRecipients.map((thisRecipient: RecordModel) =>
                      recipientObjectElement(contextRecipientObject, thisRecipient))}

                  {contextRecipientObject &&
                    recipientObjectElement(contextRecipientObject)}
                </Grid>
              </Grid>

            </Grid>
          </AccordionDetails>
        </Accordion>


        {/*ALL ADDITIONAL CONTEXT OBJECTS*/}
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
            <Typography>
              Context Fields
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              {contextObjects.map(
                (contextObject: EmailContextObjectModel) => contextObjectElement(contextObject)
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>


        {/*ALL ACTIONS (HERE ONLY PREVIEW)*/}

        <DialogActions>

          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handlePreview()
             }
            }
            sx={{width: '12%'}}
          >
            <Box sx={styles.containerRowB}>
              <Typography>
                Preview
              </Typography>
              <PreviewOutlinedIcon/>
            </Box>
          </Button>
        </DialogActions>


       {/*EMAIL CLIENT*/}
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
            <Typography>
              Email Preview
            </Typography>
          </AccordionSummary>
          <Box sx={{display: 'flex'}}>

          <Container
             sx={{
               width: '90vw'
             }}>
            {renderedTemplates.length > 0 &&
            <EmailPreviewComponent
              emailPreviews={renderedTemplates}
            />
            }
          </Container>

          </Box>
        </Accordion>


      </Box>
    )

};
